export function normalizePhoneNumber(tel: string, defaultPrefix = "+39"): string {
  const cleaned = tel.trim().replace(/\s/g, "");
  if (!cleaned) return defaultPrefix;
  if (cleaned.startsWith("+")) {
    return cleaned;
  }
  return `${defaultPrefix}${cleaned}`;
}
